"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ReactWrapper = _interopRequireDefault(require("./ReactWrapper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const selectPropsModifierFunction = props => {
  const options = props.optionsList || [];
  if (props.children && !props.optionsList) {
    props.children.forEach(child => {
      if (child.type === "option") {
        const optionObject = {
          value: child.props.value,
          label: child.props.children,
          selected: props.defaultValue ? props.defaultValue.indexOf(child.props.value) !== -1 : false
        };
        options.push(optionObject);
      }
    });
  }
  return {
    ...props,
    optionsList: options
  };
};
const ReactSelect = (0, _ReactWrapper.default)("s-select", selectPropsModifierFunction);
var _default = exports.default = /*#__PURE__*/_react.default.forwardRef(function Test(props, ref) {
  const wrappedRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, () => ({
    deselectAll: () => wrappedRef.current.element.current.deselectAll(),
    selectAll: () => wrappedRef.current.element.current.selectAll(),
    getValue: () => wrappedRef.current.element.current.getValue(),
    value: wrappedRef.current.element.current.value
  }));
  return /*#__PURE__*/_react.default.createElement(ReactSelect, _extends({
    ref: wrappedRef
  }, props));
});